import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Chip from '@material-ui/core/Chip';

const styles = () => ({
  root: {
    marginTop: 20,
  },
  chip: {
    marginRight: 10,
  },
  chipIcon: {
    fontSize: 18,
    marginLeft: 10,
    marginRight: 0,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class AnnouncementReactions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoaded: false,
      data: [],
      meta: {},
      commentText: '',
      submitting: false,
    };

    this.reloadData = this.reloadData.bind(this);
    this.onReactionClick = this.onReactionClick.bind(this);
  }

  componentDidMount() {
    this.reloadData();
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  reloadData() {
    const {
      announcement,
      selectedPupil,
    } = this.props;

    if (
      !selectedPupil ||
      announcement.allow_reactions === 'no'
    ) {
      return;
    }

    this.setState({
      isLoading: true,
    });

    axios
      .get(
        `${window.apiUrl}/announcementreactions/${announcement.id}?pupil_id=${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          this.setState({
            isLoading: false,
            isLoaded: true,
            data: response.data.data,
            meta: response.data.meta,
          });
        }
      })
      .catch((thrown) => {});
  }

  onReactionClick(reaction) {
    const {
      announcement,
      selectedPupil,
    } = this.props;

    axios
      .post(
        `${window.apiUrl}/setannouncementreaction/${announcement.id}?pupil_id=${selectedPupil.id}`,
        qs.stringify({
          reaction,
        }),
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then(() => {
        this.reloadData();
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      classes,
      t,
      announcement,
      selectedPupil,
    } = this.props;
    const {
      data,
      meta,
      isLoaded,
      isLoading,
    } = this.state;

    if (
      !selectedPupil ||
      announcement.allow_reactions === 'no'
    ) {
      return null;
    }

    return (
      <div className={`announcement-reactions ${classes.root}`}>
        {isLoading && !isLoaded && (
          <CircularProgress />
        )}
        {isLoaded && data.length > 0 && data.map((entry) => {
          return (
            <Chip
              key={entry.key}
              icon={<span>{reactions[entry.key]}</span>}
              label={entry.count}
              size="medium"
              classes={{
                root: classes.chip,
                icon: classes.chipIcon,
              }}
              color={meta.my_reaction === entry.key ? 'primary' : 'default'}
              clickable
              onClick={this.onReactionClick.bind(this, entry.key)}
            />
          );
        })}
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withSnackbar(withTranslation()(AnnouncementReactions)))
);
